var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_358",
    "data-name": "Grupo 358",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.491,
    height: 14.53,
    viewBox: "0 0 22.491 14.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.556,23.906a1.023,1.023,0,0,1-1.388.2.9.9,0,0,1-.257-1.245c.019-.028.037-.053.058-.079a10.164,10.164,0,0,0,0-11.509.9.9,0,0,1,.12-1.266.812.812,0,0,1,.079-.058,1.023,1.023,0,0,1,1.388.2,11.932,11.932,0,0,1,0,13.761Zm-5.712-2.58a1.123,1.123,0,0,1,.067-1.521,4.312,4.312,0,0,0,.992-2.778,4.531,4.531,0,0,0-.992-2.778,1.2,1.2,0,0,1-.067-1.521.914.914,0,0,1,1.282-.165.942.942,0,0,1,.108.1,6.593,6.593,0,0,1,0,8.734A.963.963,0,0,1,19.845,21.327Zm-6.7,0a.963.963,0,0,1-1.39.067,6.593,6.593,0,0,1,0-8.734.912.912,0,0,1,1.39.067,1.123,1.123,0,0,1-.067,1.521,4.531,4.531,0,0,0-.992,2.778,4.312,4.312,0,0,0,.992,2.778A1.12,1.12,0,0,1,13.145,21.327ZM8.821,24.106a1.027,1.027,0,0,1-1.389-.2,11.939,11.939,0,0,1,0-13.759,1.024,1.024,0,0,1,1.389-.2.9.9,0,0,1,.257,1.245c-.017.026-.037.053-.057.078a10.164,10.164,0,0,0,0,11.509.955.955,0,0,1-.2,1.324Z",
    transform: "translate(-5.25 -9.761)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.764,
    cy: 1.764,
    rx: 1.764,
    ry: 1.764,
    transform: "translate(9.481 5.502)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.a823f12a1b94f610084138f7c482c8ba.svg";
export { ForwardRef as ReactComponent };